import { useCallback } from 'react';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { useBranches } from '../../../../state/Branches/hooks/useBranches';
import { NodeTypeKeys } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { BranchesPayload } from '../../../../state/Branches/BranchesState';

export const useAddNewBranch = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  const { addBranches } = useBranches();

  return useCallback(
    (branchControlNodeId: string) => {
      const { nodes, edges } = Canvas.createFromState(state)
        .createBranch(branchControlNodeId)
        .convertToState();

      const branchNodes = nodes.filter(s => s.type === NodeTypeKeys.branchNameNodeType);
      const newBranch = branchNodes[branchNodes.length - 1];
      const payload: BranchesPayload = { [newBranch.id]: { id: newBranch.id } };
      addBranches(payload);

      dispatch({
        type: 'UPDATE',
        payload: {
          nodes,
          edges,
        },
      });
    },
    [addBranches, dispatch, state],
  );
};
